import request from 'request-promise';

import thunker from './thunker';
import { WAITLIST_API_URL } from './urls';


export const SUBMIT_EMAIL = "SUBMIT_EMAIL";
export const SUBMIT_EMAIL_FAILURE = "SUBMIT_EMAIL_FAILURE";
export const SUBMIT_EMAIL_SUCCESS = "SUBMIT_EMAIL_SUCCESS";
export const SUBMIT_ZIP = "SUBMIT_ZIP";
export const SUBMIT_ZIP_FAILURE = "SUBMIT_ZIP_FAILURE";
export const SUBMIT_ZIP_SUCCESS = "SUBMIT_ZIP_SUCCESS";
export const SKIP_ZIPCODE = "SKIP_ZIPCODE";


export const submitEmail = (email) => {
  return thunker({
    types: [
      SUBMIT_EMAIL,
      SUBMIT_EMAIL_SUCCESS,
      SUBMIT_EMAIL_FAILURE,
    ],
    promise: joinWaitlist(email),
    data: { email }
  });
};

function verifyEmail(email) {
  // TODO: ADD FRONT_END EMAIL VERIFICATION HERE
  if (email) {
    return true;
  } else {
    return false;
  }
}

function joinWaitlist(email) {
  return new Promise((resolve, reject) => {
    const emailError = new Error('Please confirm your email is correct.');

    if (verifyEmail(email)) {
      const options = {
        method: 'POST',
        body: { email },
        uri: `${WAITLIST_API_URL}/createWaitlistPerson`,
        json: true,
      };

      request(options)
        .then((res) => {
           resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    } else {
      reject(emailError);
    }
  });
};

export const addZipcode = (zipcode, token) => {
  return thunker({
    types: [
      SUBMIT_ZIP,
      SUBMIT_ZIP_SUCCESS,
      SUBMIT_ZIP_FAILURE,
    ],
    promise: updateWithZip(zipcode, token),
    data: { zipcode },
  });
}

function verifyZipcode(zip) {
  // TODO: add front-end zipcode verification
  if (zip && zip.length === 5) {
    return true;
  } else {
    return false;
  }
}

function updateWithZip(zip, token) {
  return new Promise((resolve, reject) => {
    const zipError = new Error('Please confirm your ZIP Code is correct');

    if (verifyZipcode(zip)) {
      const options = {
        method: 'PUT',
        body: { zip, token },
        uri: `${WAITLIST_API_URL}/updatePersonWithZip`,
        json: true,
      };

      request(options)
        .then((res) => {
           resolve(true);
        })
        .catch((err) => {
          reject(zipError);
        });
    } else {
      reject(zipError);
    }
  });
};

export const skipZipcode = () => (
  (dispatch) => { dispatch({ type: SKIP_ZIPCODE }) }
);



// WEBPACK FOOTER //
// ./src/actions/waitlist.js